import React from 'react';

import 'Components/SettingsContentLayout/SettingsContentLayout.scss';

export default function LoadingPlaceholder() {
  return (
    <div className="settingsContentLayout settingsContentLayout_loading">
      <span className="settingsContentLayout__loadingSpinner" />
    </div>
  );
}
